// extracted by mini-css-extract-plugin
export default {"countryFlag":"country-flag_countryFlag__m4osM","flagFallback":"country-flag_flagFallback__BtRAH","large":"country-flag_large__fgfNa","countryName":"country-flag_countryName__ybCay"};